/* Red Line editorial behaviour (loaded by the pa-rl-* sections; runs once per page).
   1. Desktop section tabs: resolve each tab's target by selector, drop tabs with no target,
      stick below the theme's show-on-scroll-up header, mark the current tab.
   2. Photo band: the photo settles from 1.08 to 1 as it enters (skipped for reduced motion).
   3. Feature stack: "Choose your pack" scrolls back to the pack picker. */
(function () {
  'use strict';
  if (window.__paRlEditorial) return;
  window.__paRlEditorial = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function scrollToEl(node, offset) {
    if (!node) return;
    var top = node.getBoundingClientRect().top + window.scrollY - (offset || 0);
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
  }

  function headerBottom() {
    var header = $('.shopify-section-header');
    return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  }

  /* First element matching `sel` that sits after `after` in the document. */
  function firstAfter(sel, after) {
    var list = $$(sel);
    for (var i = 0; i < list.length; i++) {
      if (!after || (after.compareDocumentPosition(list[i]) & Node.DOCUMENT_POSITION_FOLLOWING)) return list[i];
    }
    return null;
  }

  /* ---------- 1. tabs ---------- */
  var RESOLVE = {
    overview: function (nav) { return firstAfter('.pa-rl-band', nav); },
    specs: function (nav) {
      var b = firstAfter('.ballistics', nav);
      return b ? ($('.ballistics__heading', b) || b) : null;
    },
    ballistics: function (nav) {
      var hero = firstAfter('.ballistics-hero', nav);
      if (!hero) return null;
      var prev = hero.previousElementSibling;
      return prev && prev.classList.contains('ballistics__heading') ? prev : hero;
    },
    shipping: function (nav) { return firstAfter('.pa-rl-promise', nav); },
    faq: function (nav) {
      var d = firstAfter('.product-details', nav);
      if (!d) return null;
      var sec = d.closest('.shopify-section');
      return (sec && $('.title-wrapper', sec)) || d;
    }
  };

  function initTabs(nav) {
    var wrapper = nav.closest('.shopify-section') || nav;
    var links = [];
    $$('.pa-rl-tabs__link', nav).forEach(function (a) {
      var key = a.getAttribute('data-tab');
      var target = RESOLVE[key] ? RESOLVE[key](nav) : null;
      if (!target || target.offsetParent === null) {
        a.parentNode.parentNode.removeChild(a.parentNode);
        return;
      }
      a._target = target;
      links.push(a);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        // The theme header can be showing when the jump ends, so always leave room for it.
        var header = $('.shopify-section-header');
        var extra = header ? header.offsetHeight : 0;
        scrollToEl(target, nav.offsetHeight + extra + 24);
        a.setAttribute('aria-current', 'true');
      });
    });
    // Two tabs (e.g. Shipping + FAQ on a T-shirt) aren't worth a sticky bar.
    if (links.length < 3) { wrapper.style.display = 'none'; return; }
    nav.classList.add('is-ready');

    var raf = 0;
    function update() {
      raf = 0;
      var hb = headerBottom();
      wrapper.style.setProperty('--pa-rl-tabs-top', Math.round(hb) + 'px');
      var line = nav.offsetHeight + hb + 48;
      var current = null;
      links.forEach(function (a) {
        if (a._target.getBoundingClientRect().top <= line) current = a;
      });
      links.forEach(function (a) {
        if (a === current) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      nav.classList.toggle('is-stuck', wrapper.getBoundingClientRect().top <= hb + 1);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* ---------- 2. band motion ---------- */
  function initBand(band) {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    // Only animate a band that starts below the fold; one already in view stays still.
    if (band.getBoundingClientRect().top < window.innerHeight) return;
    band.classList.add('is-pre');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { band.classList.add('is-in'); io.disconnect(); }
      });
    }, { threshold: 0.15 });
    io.observe(band);
  }

  /* ---------- 3. "Choose your pack" ---------- */
  function initPackButtons() {
    var picker = $('variant-selects[data-primary]');
    $$('[data-pa-rl-pack]').forEach(function (btn) {
      if (!picker) return;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        scrollToEl(picker, headerBottom() + 120);
        var checked = $('input:checked', picker) || $('input', picker);
        if (checked) setTimeout(function () { checked.focus({ preventScroll: true }); }, REDUCED ? 0 : 600);
      });
    });
  }

  function start() {
    $$('.pa-rl-tabs').forEach(initTabs);
    $$('.pa-rl-band').forEach(initBand);
    initPackButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
